export const logoutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("contractIdSelected");
  window.location.reload();
};
